module.exports = __webpack_public_path__ + "img/south-sudan.39ec258e.png";